import styled from 'styled-components';
import { fontSizeRem, heightRem } from './constants';

export const ColorLegendContainer = styled.div`
  display: flex;
  font-size: ${fontSizeRem}rem;
  flex-direction: row;
  height: ${heightRem + fontSizeRem / 2}rem;
  justify-content: space-between;
  margin-left: 1.5em;
  margin-top: 2em;
  pointer-events: none;
  z-index: 10;
`;
